import classNames from "classnames";
import { observer } from "mobx-react";
import React from "react";
import { L10nHtml } from "@fidget/common/i18n";
import { intl } from "@fidget/common/i18n/TypedIntl";
import LogotypeDashboardImage from "../../../assets/logotype_dashboard.svg";
import styles from "./welcomeToHeader.css";

interface Props {
  timeToAnimate?: number;
  styleType: "signup" | "login";
}

interface State {
  displayMode: "big" | "small";
}

@observer
export class WelcomeToHeader extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      displayMode: props.timeToAnimate ? "big" : "small"
    };
  }

  componentDidMount() {
    const { timeToAnimate } = this.props;
    if (timeToAnimate) {
      setTimeout(() => this.setState({ displayMode: "small" }), timeToAnimate);
    }
  }

  render() {
    const { styleType, children } = this.props;
    const smallText =
      styleType === "login"
        ? intl.formatMessage("login.welcome")
        : intl.formatMessage("signup.signupTo");
    const colorClass = styleType === "login" ? styles.login : styles.signup;

    return (
      <>
        <header
          className={classNames(styles["welcome-to"], colorClass, {
            [styles.small]: this.state.displayMode !== "big"
          })}
        >
          <h1>
            {this.state.displayMode === "big" ? <L10nHtml id={"signup.welcome"} /> : smallText}
          </h1>
          <img className={styles["closer-logo"]} src={LogotypeDashboardImage} alt={"CLOSER Logo"} />
        </header>
        <main>{children}</main>
      </>
    );
  }
}
